import React, { useState, useEffect } from 'react';
import api from '../lib/api';
import HeaderBlock from './blocks/HeaderBlock';
import MenuBlock from './blocks/MenuBlock';
import FooterBlock from './blocks/FooterBlock';

/**
 * GlobalBlockByType - Affiche un bloc global par type
 * 
 * Charge tous les blocs globaux et affiche celui du type demandé
 * 
 * Usage:
 * <GlobalBlockByType type="header" />
 * <GlobalBlockByType type="menu" />
 * <GlobalBlockByType type="footer" />
 */
const GlobalBlockByType = ({ type }) => {
  const [block, setBlock] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadGlobalBlocks = async () => {
      try {
        setLoading(true);
        const response = await api.get('/global-blocks');
        
        // Trouver le bloc du type demandé qui est actif
        const foundBlock = (response.data || []).find(b => b.type === type && b.is_active);
        
        if (foundBlock) {
          setBlock(foundBlock);
        } else {
          console.warn(`[GlobalBlockByType] Aucun bloc global actif de type "${type}"`);
        }
        
        setError(null);
      } catch (err) {
        console.error(`[GlobalBlockByType] Erreur chargement bloc ${type}:`, err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadGlobalBlocks();
  }, [type]);

  // Pas de rendu pendant le chargement (éviter le flash)
  if (loading) {
    return null;
  }

  // Pas de bloc trouvé
  if (error || !block) {
    return null;
  }

  // Mapper les types aux composants
  const componentMap = {
    header: HeaderBlock,
    menu: MenuBlock,
    footer: FooterBlock,
  };

  const BlockComponent = componentMap[block.type];

  if (!BlockComponent) {
    console.warn(`[GlobalBlockByType] Type de bloc inconnu: ${block.type}`);
    return null;
  }

  return (
    <div 
      data-global-block-type={block.type}
      data-global-block-id={block.id}
    >
      <BlockComponent block={block} />
    </div>
  );
};

export default GlobalBlockByType;
